import { request } from "./_request";
import moment from "moment";
import { formatData } from "../helpers/dealerProfile";

export const getChart = (type, idIndicator, idBrand, year, month) => {
  return (dispatch, getState) => {
    dispatch({
      type: "LOADING_CHART_DA_SERVICIOS",
      payload: { type: type, loading: true },
    });

    const user = JSON.parse(localStorage.getItem("@@auth_user"));

    request
      .get("/data_dashservice/chart", {
        params: {
          year: year,
          idIndicator: 1,
          idBrand: idBrand,
          month: month,
          type: type,
        },
        headers: { Authorization: `Bearer ${user.token}` },
      })
      .then((response) => {
        let data = response.data;

        if (!data.error) {
          dispatch({
            type: "READY_DATA_CHART_DA_SERVICIOS",
            payload: { data: data.result, type: type },
          });
        } else {
          if (data.code == -1) {
            localStorage.removeItem("@@auth_user");
            dispatch({
              type: "ERROR_TOKEN_MAIN",
              payload: { message: data.message, code: -1 },
            });
            dispatch({
              type: "LOADING_CHART_DA_SERVICIOS",
              payload: { type: type, loading: false },
            });
          } else {
            dispatch({ type: "ERROR_DA_SERVICIOS", payload: data.message });
            dispatch({
              type: "LOADING_CHART_DA_SERVICIOS",
              payload: { type: type, loading: false },
            });
          }
        }
      })
      .catch((e) => {
        dispatch({ type: "ERROR_DA_SERVICIOS", payload: e.message });
        dispatch({
          type: "LOADING_CHART_DA_SERVICIOS",
          payload: { type: type, loading: false },
        });
      });
  };
};

// Remove this when Sebas is done with the API
// TODO: This is a temporary solution, cause api is not ready yet
export const getNewChart = (type, idIndicator, idBrand, year, month) => {
  return (dispatch, getState) => {
    dispatch({
      type: "LOADING_CHART_DA_SERVICIOS",
      payload: { type: type, loading: true },
    });

    const user = JSON.parse(localStorage.getItem("@@auth_user"));

    return request
      .get(
        `data_dashservice/resuMonth?idIndicator=${idIndicator}&idBrand=3&type=citas&token=sdf`,
        {
          params: {
            year: year,
            month: month,
          },
          headers: { Authorization: `Bearer ${user.token}` },
        }
      )
      .then((response) => {
        dispatch({
          type: "LOADING_CHART_DA_SERVICIOS",
          payload: { type: type, loading: false },
        });
        return {
          error: false,
          result: response?.data?.result,
        };
      })
      .catch((e) => {
        dispatch({
          type: "LOADING_CHART_DA_SERVICIOS",
          payload: { type: type, loading: false },
        });
        return {
          error: true,
        };
      });
  };
};

export const getData = (year, month, type, vsMorD) => {
  return (dispatch, getState) => {
    dispatch({ type: "LOADING_DA_SERVICIOS", payload: true });

    const user = JSON.parse(localStorage.getItem("@@auth_user"));

    request
      .get("/dealer_profile/data", {
        params: { year: year, month: month, type: type },
        headers: { Authorization: `Bearer ${user.token}` },
      })
      .then((response) => {
        let data = response.data;

        if (!data.error) {
          formatData(data.result, year, month, type, vsMorD).then((result) => {
            console.log(result);
            dispatch({
              type: "READY_DATA_DA_SERVICIOS",
              payload: { data: result, rawData: data.result },
            });
          });
        } else {
          if (data.code == -1) {
            localStorage.removeItem("@@auth_user");
            dispatch({
              type: "ERROR_TOKEN_MAIN",
              payload: { message: data.message, code: -1 },
            });
            dispatch({ type: "ERROR_DA_SERVICIOS", payload: data.message });
          } else {
            dispatch({ type: "ERROR_DA_SERVICIOS", payload: data.message });
          }
        }
      })
      .catch((e) => {
        dispatch({ type: "ERROR_DA_SERVICIOS", payload: e.message });
      });
  };
};

export const getSelect = (year, month, type, vsMorD) => {
  return (dispatch, getState) => {
    dispatch({ type: "LOADING_DA_SERVICIOS", payload: true });

    const user = JSON.parse(localStorage.getItem("@@auth_user"));

    request
      .get("/dealer_profile/select", {
        headers: { Authorization: `Bearer ${user.token}` },
      })
      .then((response) => {
        let data = response.data;

        if (!data.error) {
          dispatch({ type: "READY_SELECT_DA_SERVICIOS", payload: data.result });
        } else {
          if (data.code === -1) {
            localStorage.removeItem("@@auth_user");
            dispatch({
              type: "ERROR_TOKEN_MAIN",
              payload: { message: data.message, code: -1 },
            });
            dispatch({ type: "ERROR_DA_SERVICIOS", payload: data.message });
          } else {
            dispatch({ type: "ERROR_DA_SERVICIOS", payload: data.message });
          }
        }
      })
      .catch((e) => {
        dispatch({ type: "ERROR_DA_SERVICIOS", payload: e.message });
      });
  };
};

export const changeDate = (year, month) => {
  return (dispatch, getState) => {
    dispatch({
      type: "CHANGE_DATE_DA_SERVICIOS",
      payload: { year: year, month: month },
    });
  };
};

export const changeTypeData = (type) => {
  return (dispatch, getState) => {
    dispatch({ type: "CHANGE_TYPE_DATA_DA_SERVICIOS", payload: type });
  };
};

export const changeSelectStatusChart = (type, select, value) => {
  return (dispatch, getState) => {
    let selectStatusChart = getState().dashboardServicios.selectStatusChart;
    if (
      select === "idBrand" ||
      select === "idIndicator" ||
      select === "year" ||
      select === "month"
    ) {
      dispatch({
        type: "READY_DATA_CHART_DA_SERVICIOS",
        payload: { data: null, type: type },
      });
    }
    dispatch({
      type: "CHANGE_SELECT_CHART_DA_SERVICIOS",
      payload: { type: type, select: select, value: value },
    });
  };
};

export const changeType = (type) => {
  return (dispatch, getState) => {
    dispatch({ type: "LOADING_DA_SERVICIOS", payload: true });
    let rawData = getState().dashboardServicios.rawData;
    let year = getState().dashboardServicios.year;
    let month = getState().dashboardServicios.month;
    let vsMorD = getState().dashboardServicios.vsMorD;
    formatData(rawData, year, month, type, vsMorD).then((result) => {
      dispatch({
        type: "CHANGE_TYPE_DA_SERVICIOS",
        payload: { data: result, type: type, vsMorD: vsMorD },
      });
    });
  };
};

export const changeVsMorD = (vsMorD) => {
  return (dispatch, getState) => {
    dispatch({ type: "LOADING_DA_SERVICIOS", payload: true });
    let rawData = getState().dashboardServicios.rawData;
    let year = getState().dashboardServicios.year;
    let month = getState().dashboardServicios.month;
    let type = getState().dashboardServicios.type;
    formatData(rawData, year, month, type, vsMorD).then((result) => {
      dispatch({
        type: "CHANGE_TYPE_DA_SERVICIOS",
        payload: { data: result, type: type, vsMorD: vsMorD },
      });
    });
  };
};
